const podiumConfig = [
  { blockH: '50px', scale: 0.95, number: '2' },
  { blockH: '72px', scale: 1, number: '1' },
  { blockH: '50px', scale: 0.95, number: '3' },
];

const resolveImage = (p) => {
  if (!p) return null;
  if (/^https?:\/\//i.test(p)) return p;
  return `${process.env.REACT_APP_BASE_URL}${p}`;
};

function WinnerCard({ winner, podium, index }) {
  const isFirst = podium.number === '1';
  const portrait = winner.portrait_image ? resolveImage(winner.portrait_image) : null;

  return (
    <div className="flex flex-col" data-aos="fade-up" data-aos-delay={index * 100}>
      <div
        className={`spss-card-glow p-3 tablet:p-4 text-center ${isFirst ? 'spss-winner-highlight' : ''}`}
        style={{ width: `${100 * podium.scale}%`, alignSelf: 'center' }}
      >
        <div className="spss-image-placeholder mx-auto mb-2" style={{ width: '100%', aspectRatio: '3/4', borderRadius: '10px' }}>
          {portrait ? (
            <img
              src={portrait}
              alt={winner.name}
              style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit' }}
            />
          ) : (
            <span style={{ fontFamily: "'VT323', monospace", fontSize: '0.65rem', color: 'rgba(0,200,255,0.3)', position: 'relative', zIndex: 2 }}>Portrait</span>
          )}
        </div>
        <div style={{ height: '44px', overflow: 'hidden' }}>
          <p className="font-bold" style={{ color: '#ffffff', fontSize: '0.85rem', marginBottom: '2px', lineHeight: '1.2' }}>{winner.name}</p>
          <p style={{ fontFamily: "'VT323', monospace", fontSize: '0.75rem', color: isFirst ? 'rgba(168,130,255,0.9)' : 'rgba(100,210,255,0.75)', textShadow: '0 0 6px rgba(147,224,252,0.15)', lineHeight: '1.2' }}>
            {winner.place || winner.place_number}
          </p>
        </div>
      </div>
      <div className="spss-podium-block flex items-center justify-center" style={{ height: podium.blockH, marginTop: '-1px', borderRadius: '10px 10px 0 0' }}>
        <span className="spss-podium-number" style={{ opacity: isFirst ? 1 : 0.6 }}>{podium.number}</span>
      </div>
    </div>
  );
}

export default function WinnerSection({ type, title, subtitle, congrats, winners }) {
  if (!winners || winners.length === 0) return null;

  const dataTitle = title || 'WINNERS';
  const dataSubtitle = subtitle || type === 'glance' ? 'Glance Competition' : 'Smile Competition';
  const dataCongrats = congrats || 'CONGRATS !';

  const list = [...winners].sort((a, b) => (a.place_number || 0) - (b.place_number || 0)).slice(0, 3);
  const podiumOrder = [1, 0, 2];

  return (
    <section id={type === 'glance' ? 'winners-glance' : 'winners-smile'} className="py-10 tablet:py-16 px-3">
      <div className="max-w-5xl mx-auto">
        <div className="spss-card-subtle p-4 tablet:p-8" data-aos="fade-up">
          <div className="text-center mb-6">
            <h2 className="spss-section-title mb-2">{dataTitle}</h2>
            <p className="spss-section-subtitle">{dataSubtitle}</p>
          </div>
          <div className="grid grid-cols-3 items-end gap-3 tablet:gap-5 mb-5">
            {podiumOrder.map((winnerIdx, i) => {
              const winner = list[winnerIdx];
              if (!winner) return null;
              return <WinnerCard key={i} winner={winner} podium={podiumConfig[i]} index={i} />;
            })}
          </div>
          <div className="mt-4" data-aos="fade-up" data-aos-delay="300">
            <p className="spss-congrats">{dataCongrats}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
